// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1273":"fee399d7","2893":"fee399d7","2952":"fee399d7","4277":"fee399d7","6532":"fee399d7","9423":"fee399d7"}[chunkId] + ".chunk.css";
};